import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { uploadInjectionKey as l } from "./interface.js";
import { throwError as t } from "../../_utils/naive/warn.js";
import { defineComponent as g, inject as p, h as n } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const u = "__UPLOAD_DRAGGER__", D = g({
  name: "UploadDragger",
  [u]: !0,
  setup(i, {
    slots: a
  }) {
    const e = p(l, null);
    return e || t("upload-dragger", "`n-upload-dragger` must be placed inside `n-upload`."), () => {
      const {
        mergedClsPrefixRef: {
          value: r
        },
        mergedDisabledRef: {
          value: d
        },
        maxReachedRef: {
          value: o
        }
      } = e;
      return n("div", {
        class: [`${r}-upload-dragger`, (d || o) && `${r}-upload-dragger--disabled`]
      }, a);
    };
  }
});
export {
  D as default,
  u as uploadDraggerKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/upload/src/UploadDragger.js
// module id = 982
// module chunks = 67